export const getDevicePixelRatio = (): number =>
  window.devicePixelRatio ||
  // @ts-expect-error
  window.screen.deviceXDPI / window.screen.logicalXDPI;

export const isRetinaDevice = getDevicePixelRatio() >= 2;
